import React, { useState, useEffect } from "react";
import BreadCrumb from "../../BreadCrumb";
import Layout from "../../Layout";
import { useDispatch, useSelector } from "react-redux";
import PageLoader from "../../../common/Loader";
import { ProgressBar, Button, Nav, Tab, Card } from "react-bootstrap";
import PaymentDetails from "./paymentDetailsComponent";
import ParentDetails from "./parentDetailsComponent";
import StudentDetails from "./studentDetailsComponent";
import Stepper from 'react-stepper-horizontal';
import { STUDENT, PARENT, PAYMENT, ADD_STUDENTTABORDER, ADMISSION } from "../../constants";
import { useLocation, useParams } from 'react-router';
import { getStatesList, resetStudentDataAction, studentProfileDetailsAction } from "../../../redux/actions/studentActions";


const AddStudent = (props) => {
  const dispatch = useDispatch();
  const params = useParams();
  // const paymentDetailsData = {
  //   courseFee: 0,
  //   totalFee : 0
  // }
  const id = params.id;
  const initialProgress = 100 / Object.keys(ADD_STUDENTTABORDER).length;
  const { loader ,studentProfileDetails  } = useSelector((state) => state.student);
  const [sideMenu, setSideMenu] = useState(true);
  const [selectedTab, setSelectedTab] = useState(STUDENT);
  const [paymentDetailsData, setPaymentDetailsData] = useState({
    courseFee: 0,
    totalFee: 0
  })
  const onSideMenu = (value) => {
    setSideMenu(value);
  };

  useEffect(()=>{
    dispatch(resetStudentDataAction())
    if(id){
     async function getStudentProfileDetails(){
       await dispatch(studentProfileDetailsAction({studentId: id}))
     }
      getStudentProfileDetails();
    }else{
      setSelectedTab(STUDENT)
    }
    dispatch(getStatesList())
  },[])

  useEffect(() => {
    if(id){
      if(studentProfileDetails && !studentProfileDetails.Addresses){
        setSelectedTab(STUDENT);
      }else if(studentProfileDetails && studentProfileDetails.guardian_info && studentProfileDetails.guardian_info.length ==0  ){
        setSelectedTab(PARENT)
      }else{
        setSelectedTab(PAYMENT);
        setPaymentDetailsData({
          courseFee: studentProfileDetails.courseFee,
          totalFee: studentProfileDetails.courseFee
        })
      }

    
    }else{
      setSelectedTab(STUDENT)
    }
  }, [studentProfileDetails])

  const changeTab =(value)=>{
    setSelectedTab(value);
  } 
  
  return (
    <div className="page-wrapper">
      <Layout onClick={onSideMenu} />
      <PageLoader loader={loader}>
        <div
          className={`main-content d-flex flex-column ${
            sideMenu ? "" : "hide-sidemenu"
          }`}
        >
          <div className="main-content-header">
            <BreadCrumb />
          </div>
            <Stepper steps={ [{title: 'Student Details'}, {title: 'Parent Details'}, {title: 'Payment'}, {title: 'Payment Confirmation'}] } 
            activeStep={ ADD_STUDENTTABORDER.indexOf(selectedTab) } 
            completeBarColor={"#1c5984"} activeTitleColor={"#1c5984"} activeColor={"#1c5984"} completeColor={"#1c5984"} icon={"fa fa-user"}/>
            <hr />
            <div className="custom-tabs pill-tab ">
              <Tab.Container activeKey={selectedTab} id="left-tabs-example" defaultActiveKey={selectedTab}>
                <Nav variant="pills" className="tabs-style-two">
                  <Nav.Item>
                    <Nav.Link
                      eventKey={STUDENT}
                      onClick={() => {
                        setSelectedTab(STUDENT);
                      }}
                      disabled={STUDENT !== selectedTab}
                    >
                      <b>Student Details</b>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      eventKey={PARENT}
                      onClick={() => {
                        setSelectedTab(PARENT);
                      }}
                      disabled={PARENT !== selectedTab}
                    >
                      <b>Parent Details</b>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      eventKey={PAYMENT}
                      onClick={() => {
                        setSelectedTab(PAYMENT);
                      }}
                      disabled={PAYMENT !== selectedTab}
                    >
                      <b>Payment Details</b>
                    </Nav.Link>
                  </Nav.Item>
                </Nav>

                <Tab.Content>
                  <Tab.Pane eventKey={STUDENT}>
                    <Card>
                    <Card.Header> Student Details </Card.Header>
                      <Card.Body>
                      <StudentDetails changeTab={changeTab} redirectFrom={ADMISSION}/>
                      </Card.Body>
                    </Card>
                  </Tab.Pane>

                  <Tab.Pane eventKey={PARENT}>
                  <Card>
                    {/* <Card.Header> Parent Details </Card.Header> */}
                      <Card.Body>
                      {
                        Object.keys(studentProfileDetails).length  > 0 ? (
                          <ParentDetails changeTab={changeTab}/>
                        ) : null 
                      }   
                      
                      </Card.Body>
                    </Card>
                    
                  </Tab.Pane>

                  <Tab.Pane eventKey={PAYMENT}>
                      
                    <Card>
                    <Card.Header> Payment Details </Card.Header>
                      <Card.Body>
                      {
                        (Object.keys(studentProfileDetails).length && studentProfileDetails.courseFee > 0 ) > 0 ? (
                          <PaymentDetails payFrom={ADMISSION} payData={studentProfileDetails}/> 
                        ) : null 
                      }      
                      </Card.Body>
                    </Card>           
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
            <hr />
            
        </div>
      </PageLoader>
    </div>
  );
};

export default AddStudent;
